import { GLServiceBase, ServiceRoute } from "commonui";
import { ITotalReportManager } from "./interface";
import { LFCodeUnitCountResponseModel, LFCodeUnitCountParamsModel } from "./model";

class TotalReportServiceClass extends GLServiceBase<any, any> implements ITotalReportManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getLFCodeUnitCount(params: LFCodeUnitCountParamsModel): Promise<LFCodeUnitCountResponseModel[]> {
		return this.get("lfCodeUnitCount", { params });
	}
}

export const TotalReportManagerService = () => new TotalReportServiceClass();
